// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategorizeAllManagement_main__qkuQe {
    position: relative;
    width: 100%;
    height: 100%;
}

.CategorizeAllManagement_header__tFflb {
    display: flex;
    justify-content: space-between;
    height: 35px;
    margin-bottom: 25px;
}

.CategorizeAllManagement_title__YrxdW {
    font-size: 30px;
}

.CategorizeAllManagement_container__fI7Ih {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: calc(100% - 60px);
    min-height: calc(100% - 60px);
    padding: 20px;
    border-radius: 6px;
    background-color: #ffffff;
}

.CategorizeAllManagement_container_null__j0GI5 {
    padding: 20px;
    font-size: 20px;
    text-align: center;
}

.CategorizeAllManagement_container_left__f3P0i {
    width: 65%;
}

.CategorizeAllManagement_container_right__ih3a2 {
    width: 35%;
}

.CategorizeAllManagement_pie_left_item__IXdSB {
    width: 100%;
    height: 100%;
}

.CategorizeAllManagement_pie_right_item__tn5Oi {
    width: 100%;
    height: 33%;
}

.CategorizeAllManagement_floating_window__o9YT5 {
    position: absolute;
    width: 50%;
    height: 100%;
    top: 0;
    right: 0;
    padding: 50px 20px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 6px;
}

.CategorizeAllManagement_custom_close_button__MVK2w {
    position: absolute;
    top: 5px;
    left: 5px;
}

.CategorizeAllManagement_floating_window_content__r9TTg {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    background-color: #e6e6e6;
}

.CategorizeAllManagement_item_box__U7DLN {
    display: flex;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/CategorizeAllManagement/index.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,6BAA6B;IAC7B,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,MAAM;IACN,QAAQ;IACR,kBAAkB;IAClB,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".main {\n    position: relative;\n    width: 100%;\n    height: 100%;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    height: 35px;\n    margin-bottom: 25px;\n}\n\n.title {\n    font-size: 30px;\n}\n\n.container {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    height: calc(100% - 60px);\n    min-height: calc(100% - 60px);\n    padding: 20px;\n    border-radius: 6px;\n    background-color: #ffffff;\n}\n\n.container_null {\n    padding: 20px;\n    font-size: 20px;\n    text-align: center;\n}\n\n.container_left {\n    width: 65%;\n}\n\n.container_right {\n    width: 35%;\n}\n\n.pie_left_item {\n    width: 100%;\n    height: 100%;\n}\n\n.pie_right_item {\n    width: 100%;\n    height: 33%;\n}\n\n.floating_window {\n    position: absolute;\n    width: 50%;\n    height: 100%;\n    top: 0;\n    right: 0;\n    padding: 50px 20px;\n    background-color: rgba(0, 0, 0, 0.2);\n    border-radius: 6px;\n}\n\n.custom_close_button {\n    position: absolute;\n    top: 5px;\n    left: 5px;\n}\n\n.floating_window_content {\n    width: 100%;\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    background-color: #e6e6e6;\n}\n\n.item_box {\n    display: flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `CategorizeAllManagement_main__qkuQe`,
	"header": `CategorizeAllManagement_header__tFflb`,
	"title": `CategorizeAllManagement_title__YrxdW`,
	"container": `CategorizeAllManagement_container__fI7Ih`,
	"container_null": `CategorizeAllManagement_container_null__j0GI5`,
	"container_left": `CategorizeAllManagement_container_left__f3P0i`,
	"container_right": `CategorizeAllManagement_container_right__ih3a2`,
	"pie_left_item": `CategorizeAllManagement_pie_left_item__IXdSB`,
	"pie_right_item": `CategorizeAllManagement_pie_right_item__tn5Oi`,
	"floating_window": `CategorizeAllManagement_floating_window__o9YT5`,
	"custom_close_button": `CategorizeAllManagement_custom_close_button__MVK2w`,
	"floating_window_content": `CategorizeAllManagement_floating_window_content__r9TTg`,
	"item_box": `CategorizeAllManagement_item_box__U7DLN`
};
export default ___CSS_LOADER_EXPORT___;
